<i18n>
	{
		"en": {
			"guide": {
				"title": "On this page, you can apply for a treatment day compensation and initial assistance",
				"description": "You can apply for initial assistance once, or again if your cancer recurs. Additionally, you can apply for treatment day compensation for the days you've been in cancer treatment.",
				"cta": "See detailed instructions"
			},
			"membershipDetails": {
				"title": "Your membership began on:",
				"description": "Polite reminder. You can claim compensation from the start date of your membership at the earliest."
			},
			"alkuavustusExtraDetails": {
				"title": "When applying for initial assistance, you need a certificate from the provider. You can find the attached file in our material banke",
				"cta": "Move to material bank here"
			},
			"formApply": {
				"title": "Apply for compensation or initial assistance",
				"cta": "Fill the form"
			},
			"updateAllDetails": {
				"header": "You are missing key information from your account",
				"title": "Please also update your bank account number and birth year",
				"cta": "to your own details"
			},
			"updateAllDetails": {
				"title": "Update your banking details and birthdate",
				"cta": "Fill missing details"
			},
			"updateAllDetails": {
				"header": "You are missing key details from your account details",
				"title": "Remember to update your bank details and birthdate.",
				"cta": "Own details"
			},
			"updateYearOfBirth": {
				"title": "Update your birth year"
			},
			"updateIban": {
				"title": "Update your Iban"
			},
			"compensations": {
				"title": "Applied compensations",
				"noItems": "No compensation applications found"
			}
		},
		"fi": {
			"guide": {
				"title": "Tällä sivulla voit hakea hoitopäiväkorvausta ja alkuavustusta",
				"description": "Ystävällinen muistutus. Voit hakea alkuavustusta kerran, tai uudelleen jos syöpäsairautesi uusiutuu. Lisäksi voit hakea hoitopäiväkorvausta niiltä päiviltä, jolloin olet ollut syöpähoidossa.",
				"cta": "Katso tarkemmat ohjeet"
			},
			"membershipDetails": {
				"title": "Jäsenyytesi on alkanut:",
				"description": "Voit hakea korvauksia aikaisintaan jäsenyytesi alkamispäivästä."
			},
			"alkuavustusExtraDetails": {
				"title": "Alkuavustusta hakiessasi tarvitset hoitavan tahon todistuksen. Löydät todistuspohjan materiaalipankistamme",
				"cta": "Siirry materiaalipankkiin"
			},
			"formApply": {
				"title": "Hae korvausta tai alkuavustusta",
				"cta": "Täytä lomake"
			},
			"updateAllDetails": {
				"header": "Sinulta puuttuu oleellista jäsentietoa tililtäsi",
				"title": "Päivitäthän myös tilinumerosi ja syntymävuotesi",
				"cta": "Päivitä tietosi"
			},
			"updateYearOfBirth": {
				"title": "Päivitäthän syntymävuotesi"
			},
			"updateIban": {
				"title": "Päivitäthän myös tilinumerosi"
			},
			"compensations": {
				"title": "Haetut korvaushakemukset",
				"noItems": "Ei korvaushakemuksia"
			}
		}
	}
</i18n>
<template>
	<div>
		<!-- Output child page -->
		<router-view :key="$route.fullPath" />

		<!-- Output navigation if we're not on child page -->
		<template v-if="$route.name == 'compensations'">
			<v-container class="container--narrow">
				<v-container>
					<v-card>
						<v-card-title>
							{{ $i18n.t('guide.title') }}
						</v-card-title>
						<v-card-text>
							{{ $i18n.t('guide.description') }}
						</v-card-text>
						<v-card-actions>
							<v-btn
								text
								href="https://www.lounais-suomensyopayhdistys.fi/jasenyys/korvaus/"
								color="info"
								target="_blank"
							>
								{{ $i18n.t('guide.cta') }}
							</v-btn>
						</v-card-actions>
						<v-spacer />
						<v-card-text>
							{{ $i18n.t('membershipDetails.title') }}
							<strong>
								{{ user._membership_startdate }}
							</strong>
							<v-spacer />
							{{ $i18n.t('membershipDetails.description') }}
						</v-card-text>
						<v-card-text>
							{{ $i18n.t('alkuavustusExtraDetails.title') }}
							<v-spacer />
							<v-card-actions>
								<v-btn
									:to="{ name: 'materials', params: { pageName: 'materials' }}"
									text
									color="info"
									target="_blank"
								>
									{{ $i18n.t('alkuavustusExtraDetails.cta') }}
								</v-btn>
							</v-card-actions>
						</v-card-text>
					</v-card>
				</v-container>

				<v-container v-if="user.iban == '' || user.c_year_of_birth == ''">
					<v-card>
						<v-card-title>
							{{ $i18n.t('updateAllDetails.header') }}
						</v-card-title>
						<v-subheader>
							{{ dynamicTitle }}
						</v-subheader>
						<v-card-actions>
							<v-btn
								color="primary"
								text
								:to="{ name: 'myAccount' }"
							>
								{{ $i18n.t('updateAllDetails.cta') }}
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-container>

				<v-container>
					<v-card>
						<v-card-title>
							{{ $i18n.t('formApply.title') }}
						</v-card-title>
						<v-card-actions>
							<v-btn
								to="/compensations/form"
								color="primary"
							>
								{{ $i18n.t('formApply.cta') }}
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-container>

				<v-container>
					<v-card>
						<v-card-title>
							{{ $i18n.t('compensations.title') }}
						</v-card-title>
						<v-card-text>
							<FilterableList
								v-if="user.korvaushakemukset && user.korvaushakemukset.length"
								:items="user.korvaushakemukset"
								icon-src="_list_icon"
								icon-color-src="_list_icon_color_src"
								title-src="_list_title"
								summary-src="_list_summary"
								:enable-click="(false)"
								:enable-search="(false)"
							/>
							<v-alert
								v-else
								type="info"
							>
								{{ $i18n.t('compensations.noItems') }}
							</v-alert>
						</v-card-text>
					</v-card>
				</v-container>
			</v-container>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Compensations',

	computed: {
		...mapState([
			'user',
		]),

		dynamicTitle () {
			if (this.user.iban === '' && this.user.c_year_of_birth !== '') {
				return this.$i18n.t('updateIban.title')
			} else if (this.user.iban !== '' && this.user.c_year_of_birth == '') {
				return this.$i18n.t('updateYearOfBirth.title')
			} else if (this.user.iban === '' && this.user.c_year_of_birth == '') {
				return this.$i18n.t('updateAllDetails.title')
			}
			return '' // Default, or you can return another appropriate title if needed
		},

	},

	mounted () {
		this.$api.Me.doRequest()
	},

}
</script>
